module.exports = __webpack_public_path__ + "static/media/Spin-1s-107px.b4262a90.gif";